import { InvokeCreator } from "xstate";
import { getCheckoutPricingPlan } from "@/containers/Converter/common/helpers/getCheckoutPricingPlan";
import { PRODUCTS } from "@/constants/products";
import {
  handleCheckout,
  IHandleCheckoutResponse,
} from "@/services/checkoutService";
import { IContext } from "./types";

export const handleCheckoutService: InvokeCreator<IContext, any> = async (
  ctx,
): Promise<IHandleCheckoutResponse> => {
  const { isFigmaBackup, figmaPlanId, planQuantity, paymentType } = ctx;

  if (isFigmaBackup && figmaPlanId) {
    return handleCheckout({
      planId: figmaPlanId,
      conversionType: "",
      planQuantity,
    });
  }

  const checkoutPlan = getCheckoutPricingPlan(paymentType!);
  const planId = PRODUCTS[checkoutPlan];

  return handleCheckout({
    planId,
    conversionType: "",
  });
};
